import { ConnectedPosition } from '@angular/cdk/overlay';

export const IMenuPosition: IConnectedPositions = {
  topLeft: [{ originX: 'start', originY: 'top', overlayX: 'end', overlayY: 'bottom' }],
  topRight: [{ originX: 'end', originY: 'top', overlayX: 'start', overlayY: 'bottom' }],
  bottomLeft: [{ originX: 'start', originY: 'bottom', overlayX: 'end', overlayY: 'top' }],
  bottomRight: [{ originX: 'end', originY: 'bottom', overlayX: 'start', overlayY: 'top' }],
};

export interface IConnectedPositions {
  topLeft: ConnectedPosition[];
  topRight: ConnectedPosition[];
  bottomLeft: ConnectedPosition[];
  bottomRight: ConnectedPosition[];
}
